var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.68 3.378c.929 0 1.682-.769 1.682-1.697a1.682 1.682 0 00-3.362 0c0 .928.753 1.697 1.68 1.697zM7.852 14V9.372c0-1.219.231-2.397 1.74-2.397 1.451 0 1.508 1.324 1.51 2.395V14H14V8.866c0-2.513-.54-4.447-3.478-4.447-1.412 0-2.358.775-2.746 1.51h-.04V4.652H4.952V14h2.9zm-4.717 0V4.653H.23V14h2.903z","fillRule":"evenodd"}));
}

Linkedin.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
